// extracted by mini-css-extract-plugin
export default {"progressText":"ProgressBar_progressText__C+2CW","progressBar":"ProgressBar_progressBar__8d4AF"};